export default "__VITE_ASSET__BZH_u0Mk__"